import { withInstall } from '@antdv/utils';
import ASwitch from './src/Switch';

export const Switch = withInstall(ASwitch);

export default Switch;

export * from './src/interface';
export * from './src/props';
